import React, { useState } from 'react';
import { Present } from '@lux/graphics';
import { ComplementaryColor } from '@lux/tokens';
import { EducationalMessage, NewsletterSubscriptionDialog, HideEducationalMessageCookieNames, } from '@pegasus/platform-journeys';
import { Translate, TranslateScope, useTranslate } from '@pegasus/translation';
import { track } from '../../../../lib/tracking';
import { HOMEPAGE_LOGIN, logout } from '../../../../lib/logout';
import { Wrapper } from './styles';
const NewsletterUnsubscribedUsersEducationalMessage = ({ showSuccessMessage, showNotification, isDOIUser, subscribeToNewsletter, email, firstName, csrfToken, hasSecondaryAuth, children, }) => {
    const [isNewsletterSubscriptionDialogShown, setIsNewsletterSubscriptionDialogShown] = useState(false);
    const translate = useTranslate();
    const showNewsletterSubscriptionDialog = () => setIsNewsletterSubscriptionDialogShown(true);
    const hideNewsletterSubscriptionDialog = () => setIsNewsletterSubscriptionDialogShown(false);
    const onLogout = () => {
        logout(csrfToken, HOMEPAGE_LOGIN);
    };
    return (React.createElement(React.Fragment, null,
        children({ showNewsletterSubscriptionDialog }),
        React.createElement("div", { onMouseDown: e => {
                if (isNewsletterSubscriptionDialogShown) {
                    e.nativeEvent.stopImmediatePropagation();
                }
            } },
            React.createElement(NewsletterSubscriptionDialog, { hide: hideNewsletterSubscriptionDialog, onSubscribe: async () => {
                    await subscribeToNewsletter().catch(() => { });
                    hideNewsletterSubscriptionDialog();
                    if (isDOIUser) {
                        showNotification();
                    }
                    else {
                        showSuccessMessage(translate('voucherApplyMessage'));
                        track('snackbarMessage_view_applyVoucher');
                    }
                }, isShown: isNewsletterSubscriptionDialogShown, email: email, firstName: firstName, hasSecondaryAuth: hasSecondaryAuth, onLogout: onLogout }))));
};
const noop = () => { };
export const CartEducationalMessage = ({ isDOIUser, isSubscribedToNewsletter, isPlatformJourneyEnabled, showSuccessMessage, showNotification, subscribeToNewsletter, onHideEducationalMessage = noop, firstName, email, hasSecondaryAuth, csrfToken, }) => {
    if (!isPlatformJourneyEnabled) {
        return null;
    }
    const onVisibleTrackingEvent = isSubscribedToNewsletter
        ? 'educationMessage_view.voucherToBeApplied'
        : 'educationMessage_view.newsletterSignup';
    const onDismissTrackingEvent = isSubscribedToNewsletter
        ? 'educationMessage_view.voucherToBeApplied'
        : 'educationMessage_close.newsletterSignup';
    const educationalMessageProps = {
        isPlatformJourneyEnabled,
        title: isSubscribedToNewsletter ? (React.createElement(Translate, { message: "cartNewsletterSubscribedTitle" })) : (React.createElement(Translate, { message: "cartNewsletterSubscriptionTitle" })),
        text: isSubscribedToNewsletter ? (React.createElement(Translate, { message: "cartNewsletterSubscribedText" })) : (React.createElement(Translate, { message: "cartNewsletterSubscriptionText" })),
        cookieName: HideEducationalMessageCookieNames.Cart,
        // @ts-ignore
        icon: React.createElement(Present, { bgColor: ComplementaryColor.brand20 }),
        onVisible: () => track(onVisibleTrackingEvent),
        onDismiss: () => {
            track(onDismissTrackingEvent);
            onHideEducationalMessage();
        },
        descriptionTextTop: true,
        descriptionTextBottom: false,
    };
    if (isSubscribedToNewsletter) {
        return (React.createElement(TranslateScope, { path: "educationalMessages" },
            React.createElement(Wrapper, null,
                React.createElement(EducationalMessage, { ...educationalMessageProps }))));
    }
    return (React.createElement(TranslateScope, { path: "newsletterDialog" },
        React.createElement(NewsletterUnsubscribedUsersEducationalMessage, { showSuccessMessage: showSuccessMessage, showNotification: showNotification, isDOIUser: isDOIUser, subscribeToNewsletter: subscribeToNewsletter, firstName: firstName, email: email, hasSecondaryAuth: hasSecondaryAuth, csrfToken: csrfToken }, ({ showNewsletterSubscriptionDialog }) => (React.createElement(TranslateScope, { path: "educationalMessages" },
            React.createElement(Wrapper, null,
                React.createElement(EducationalMessage, { ...educationalMessageProps, linkText: React.createElement(Translate, { message: "cartNewsletterSubscriptionCta" }), onLinkClick: () => {
                        track('educationMessage_click.newsletterSignup');
                        showNewsletterSubscriptionDialog();
                    } })))))));
};
//# sourceMappingURL=index.js.map